import UnusualAccessLock from './UnusualAccessLock';
export default UnusualAccessLock;
